export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-orange-600 to-orange-500 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/a217ef276c86b3f83e8ac6a753790dbf/ed9fe3a5ad6190d6ed0f845908f8f102.png" 
              alt="Toolbox Property Pros" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/90 mb-4 leading-relaxed">
              Your trusted partner for comprehensive property maintenance solutions.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Pool Services</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Pressure Washing</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Gutter Cleaning</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Window Cleaning</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Junk Removal</button></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white transition-colors cursor-pointer">About Us</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Our Services</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Contact</button></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Careers</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-fill text-xl mt-1"></i>
                <a href="tel:+16262447341" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  (626) 244-7341
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-fill text-xl mt-1"></i>
                <a href="mailto:info@toolboxpropertypros.com" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  info@toolboxpropertypros.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-fill text-xl mt-1"></i>
                <span className="text-white/80">
                  Mon-Sat: 7AM - 7PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/80 text-sm">
              © 2024 Toolbox Property Pros. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}